import { render, staticRenderFns } from "./CheckboxInfo.vue?vue&type=template&id=12495ffe&scoped=true&"
import script from "./CheckboxInfo.vue?vue&type=script&lang=ts&"
export * from "./CheckboxInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxInfo.vue?vue&type=style&index=0&id=12495ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12495ffe",
  null
  
)

export default component.exports